import { Controller } from 'stimulus'
import { useDebounce } from 'stimulus-use'

export default class extends Controller {
  static targets = ['searchInputContainer', 'searchInput', 'searchToggle']
  static debounces = ['search']

  connect() {
    useDebounce(this)
    this.searchActive = false
  }

  showSearchInput() {
    this.searchInputContainerTarget.classList.remove('hidden')
    this.searchToggleTarget.classList.add('hidden')
    this.searchInputTarget.focus()
    this.searchActive = true
  }

  hideSearchInput() {
    this.searchInputTarget.value = ''
    this.searchInputContainerTarget.classList.add('hidden')
    this.searchToggleTarget.classList.remove('hidden')
    this.searchActive = false
    this.search()
  }

  search() {
    const target = document.querySelector('#js-courses-paginator')
    this.dispatch('changeParam', {
      target: target,
      prefix: false,
      detail: {
        value: this.searchInputTarget.value,
        name: 'q',
      },
    })
  }

  toggleSearchInput() {
    if (this.searchActive) {
      this.hideSearchInput()
    } else {
      this.showSearchInput()
    }
  }
}
